module.exports = __webpack_public_path__ + "img/icon-main-check.8ca8a41f.svg";